import React, { useState } from 'react'
import styled from 'styled-components'
import { ReqWithMetaData } from '../types'
import { FormContext } from '../context'
import { FormArea } from './FormArea'
import { QuestionnaireSubmitRes, TaskReq } from 'packages/sdks-next/growp'
import { AnyValueObj } from 'packages/types'

/**
 * 问卷 - 预览
 *
 * @param param - 参数
 * @param param.task - 任务
 * @param param.questionnaires - 问卷结构
 * @param param.initData - 初始问卷数据（二次填写回显的数据）
 * @param param.formValues - 实时保存的问卷数据
 * @param param.setFormValues - 修改填写的问卷数据
 * @param param.otherInfo - 其它数据
 * @param param.setOtherInfo - 修改其它数据
 * @param param.onSubmit - 提交方法
 * @param param.initOtherData - 单选|多选的其它数据
 * @param param.isPreview - 是否为预览模式
 * @returns React.ReactNode
 */
export const Preview: React.FC<{
  task: TaskReq
  questionnaires: ReqWithMetaData[]
  onSubmit?: (v: object, o: object) => void
  formValues: AnyValueObj
  setFormValues: (v: AnyValueObj) => void
  otherInfo: AnyValueObj
  setOtherInfo: (v: AnyValueObj) => void
  initData?: QuestionnaireSubmitRes[]
  isPreview?: boolean
}> = ({
  task,
  questionnaires,
  onSubmit,
  formValues,
  setFormValues,
  otherInfo,
  setOtherInfo,
  initData,
  isPreview,
}) => {
  const [page, setPage] = useState<number>(1)
  return (
    <Wrapper id="questionnaire-top">
      <FormContext.Provider
        value={{
          formValues,
          setFormValues: (v) => setFormValues(v),
          setFinalFormValues: onSubmit,
          otherInfo,
          setOtherInfo: (v) => setOtherInfo(v),
        }}
      >
        {page > 1 ? null : (
          <TitleArea>
            <Title>{task.name}</Title>
            <Description>{task.description}</Description>
          </TitleArea>
        )}
        <FormArea
          questionnaires={questionnaires}
          initData={initData}
          page={page}
          setPage={(v: number) => setPage(v)}
          isPreview={isPreview}
        />
      </FormContext.Provider>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  width: 760px;
  margin: 0 auto;
  margin-top: 20px;
  border-radius: 8px;
  padding: 40px 0 40px 0;
  background-color: #ffffff;
  box-shadow: 0px 0px 1px 0px rgba(21, 29, 41, 0.2),
    0px 3px 8px -1px rgba(21, 29, 41, 0.04);
  word-break: break-all;
  word-wrap: break-word;
`

const TitleArea = styled.div`
  width: 760px;
  min-height: 70px;
  padding: 0 40px 0 40px;
`

const Title = styled.div`
  width: 100%;
  min-height: 32px;
  text-align: center;
  font-size: 24px;
  font-weight: 400;
  color: ${(props) => props.theme.text._1};
`

const Description = styled.div`
  width: 100%;
  min-height: 22px;
  margin-top: 16px;
  font-size: 14px;
  font-weight: 400;
  text-align: center;
  color: ${(props) => props.theme.text._3};
`
